import { LogoBio } from "../../../../ui/icons/logoBio";
import { GlobalGapIcon } from "../../../../ui/icons/logoGlobalGap";
import { LogoSQNPI } from "../../../../ui/icons/logoSqnpi";
import { formatterDate } from "../../../../utils";
import { CertificationBoxProps } from "./certification.types";

export const CertificationBox: React.FC<CertificationBoxProps> = ({
    ...props
}) => {
    return (
        <div className="rounded-xl border border-neutral-200 bg-white shadow-sm overflow-hidden h-full">
            <div className="bg-brandPrimary-600 px-4 py-3">
                <span className="text-white text-sm font-semibold uppercase tracking-widest">Schema certificazione</span>
            </div>

            <div className="p-4">
                <div className="flex gap-3 items-start">
                    <div className="flex-1 min-w-0">
                        <div className="text-xs font-semibold uppercase tracking-wide text-neutral-500">Normativa</div>
                        {
                            props.customer.norm === 'NORMA_BIO' && (
                                <div className="text-xl font-bold text-brandPrimary-700 mt-1">Biologico</div>
                            )
                        }

                        {
                            props.customer.norm === 'PRODUZIONE_INTEGRATA' && (
                                <div className="text-xl font-bold text-brandPrimary-700 mt-1">Produzione Integrata</div>
                            )
                        }
                        {
                            props.customer.norm === 'DETERGENZA' && (
                                <div className="text-xl font-bold text-brandPrimary-700 mt-1">Detergenza</div>
                            )
                        }

                        {
                            props.customer.norm === 'GLOBAL_GAP' && (
                                <div className="text-xl font-bold text-brandPrimary-700 mt-1">GlobalG.A.P</div>
                            )
                        }

                        {
                            props.customer.norm === 'QUALITA_SICURA' && (
                                <div className="text-xl font-bold text-brandPrimary-700 mt-1">Qualita Sicura</div>
                            )
                        }

                        {
                            props.customer.norm === 'RESIDUO_ZERO' && (
                                <div className="text-xl font-bold text-brandPrimary-700 mt-1">Residuo Zero</div>
                            )
                        }

                    </div>
                    <div className="w-[120px] flex justify-center items-start">
                        {
                            props.customer.norm === 'NORMA_BIO' && (
                                <LogoBio color="orange" size={100} />
                            )
                        }

                        {
                            props.customer.norm === 'PRODUZIONE_INTEGRATA' && (
                                <LogoSQNPI color="orange" size={100} />
                            )
                        }

                        {
                            props.customer.norm === 'GLOBAL_GAP' && (
                                <GlobalGapIcon />
                            )
                        }

                    </div>
                </div>

                <div className="pt-4 flex flex-col gap-3">
                    <div className="flex justify-between gap-4 items-start text-left">
                        <span className="text-sm font-semibold text-brandPrimary-700">Codice</span>
                        <span className="text-sm font-medium text-neutral-700">{props.customer.clientCode || '-'}</span>
                    </div>

                    <div className="border-t border-neutral-200" />
                    
                    <div className="flex justify-between gap-4 items-start text-left">
                        <span className="text-sm font-semibold text-brandPrimary-700">Attivita</span>
                        <span className="text-sm font-medium text-neutral-700">IT-001</span>
                    </div>

                    <div className="border-t border-neutral-200" />

                    <div className="flex justify-between gap-4 items-start text-left">
                        <span className="text-sm font-semibold text-brandPrimary-700">Data ingresso</span>
                        <span className="text-sm font-medium text-neutral-700">{formatterDate(props.customer.startingDate)}</span>
                    </div>

                    <div className="border-t border-neutral-200" />

                    <div className="flex justify-between gap-4 items-start text-left">
                        <span className="text-sm font-semibold text-brandPrimary-700">Data uscita</span>
                        <span className="text-sm font-medium text-neutral-700">{formatterDate(props.customer.endingDate)}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};
